import { AHText, useScaleFactor, useSpaceSize } from "arkh";

import React from "react";
import { PixelRatio } from "react-native";

import { useNoteWidgetPageTextStyle } from "widgets/src/WidgetNote/styleHelpers/useNoteWidgetStyle";
import { graphql, useFragment } from "react-relay";
import { WidgetNoteText_page$key } from "./__generated__/WidgetNoteText_page.graphql";
import { useWidgetNoteTextTopPadding } from "widgets/src/WidgetNote/useWidgetNoteTextTopPadding";

export function WidgetNoteText(props: { page: WidgetNoteText_page$key }) {
  const sf = useScaleFactor();
  const padding = useSpaceSize("medium");
  const paddingTop = useWidgetNoteTextTopPadding();

  const page = useFragment(
    graphql`
      fragment WidgetNoteText_page on WidgetNotePage {
        currentValue
        ...useNoteWidgetStyleText_widgetNotePage
      }
    `,
    props.page
  );
  const textStyle = useNoteWidgetPageTextStyle(page, { forceImage: true });

  return (
    <AHText
      allowFontScaling={false}
      style={[
        {
          padding,
          paddingTop,
          fontSize: PixelRatio.roundToNearestPixel(textStyle.fontSize * sf),
          fontStyle: textStyle.fontStyle,
          fontFamily: textStyle.fontFamily,
          textAlign: textStyle.textAlign,
          color: textStyle.color,
        },
        textStyle.textShadow,
      ]}
    >
      {page.currentValue}
    </AHText>
  );
}
